import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M4 18c-.551 0-1-.449-1-1V6h13v3h1V3c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6v-1H4zM5.5 3h8c.275 0 .5.225.5.5s-.225.5-.5.5h-8c-.275 0-.5-.225-.5-.5s.225-.5.5-.5zM19 14v-.188c0-1.553-1.343-2.813-3-2.813s-3 1.259-3 2.813V14c-.552 0-1 .448-1 1v4c0 .552.448 1 1 1h6c.552 0 1-.448 1-1v-4c0-.552-.448-1-1-1zm-5-.187c0-.999.897-1.812 2-1.812s2 .813 2 1.812v.188h-4v-.188zM10 14v1H5.5c-.275 0-.5-.225-.5-.5v-6c0-.275.225-.5.5-.5h8c.275 0 .5.225.5.5V9H6v1h6v1H6v1h5v1H6v1h4z',
  ],
  height: 20,
  width: 20,
});
